import { actionTypes } from "../actionTypeList";
import { PAGES } from "../../enum/pages";

const initialState = PAGES.HOMEPAGE;

const activePage = (state = initialState, action) => {
	switch (action.type) {
	    case actionTypes.SET_PAGE: {
	        return action.payload.page;
	    }
	    default: {
	        return state;
	    }
	}
};

export default activePage;
